module.exports = __webpack_public_path__ + "platform-web/static/media/question.8755a6c3.svg";